import { useMemo } from 'react';

import { parseInstance } from './/request-service-provider/parse-instance.js';

/**
 * Computes iframeSandboxDomain from instance if not explicitly provided.
 * Used by both Editor and Viewer to ensure consistent behavior.
 */
export const useIframeSandboxDomain = (
  explicitDomain: string | undefined,
  instance: string | undefined
): string | undefined => {
  return useMemo(() => {
    if (explicitDomain) return explicitDomain;
    if (!instance) return undefined;
    const { metaSiteId } = parseInstance(instance);
    return metaSiteId ? `https://${metaSiteId}.filesusr.com` : undefined;
  }, [explicitDomain, instance]);
};
